import {
  withTranslation,
} from 'react-i18next';

import RegattaAdminRequestFieldsView from './RegattaAdminRequestFieldsView';

const TranslatedComponent = withTranslation()(RegattaAdminRequestFieldsView);

const Component = TranslatedComponent;

export default Component;
